import { apiRes, type AttachRedirectAttributionResponse, type PracticeAPI } from "@/practice/api";

const REDIRECT_CLICK_ID_PARAM = "redirect_click_id";
const REDIRECT_CLICK_ID_STORAGE_KEY = "redirect_attribution_click_id";
const REDIRECT_CLICK_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

function normalizeRedirectClickId(value: string | null): string | null {
  if (value == null) {
    return null;
  }
  const trimmedValue = value.trim();
  if (!REDIRECT_CLICK_ID_PATTERN.test(trimmedValue)) {
    return null;
  }
  return trimmedValue;
}

export function captureRedirectAttributionFromUrl(): void {
  if (typeof window === "undefined") {
    return;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const redirectClickId = normalizeRedirectClickId(
    urlParams.get(REDIRECT_CLICK_ID_PARAM),
  );
  if (redirectClickId == null) {
    return;
  }
  try {
    window.localStorage.setItem(REDIRECT_CLICK_ID_STORAGE_KEY, redirectClickId);
  } catch (error) {
    console.error("Failed to persist redirect attribution:", error);
  }
}

export function getStoredRedirectClickId(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    return normalizeRedirectClickId(
      window.localStorage.getItem(REDIRECT_CLICK_ID_STORAGE_KEY),
    );
  } catch (error) {
    console.error("Failed to read redirect attribution:", error);
    return null;
  }
}

export function clearStoredRedirectClickId(): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.removeItem(REDIRECT_CLICK_ID_STORAGE_KEY);
  } catch (error) {
    console.error("Failed to clear redirect attribution:", error);
  }
}

export async function attachStoredRedirectAttribution(
  API: PracticeAPI,
): Promise<void> {
  const redirectClickId = getStoredRedirectClickId();
  if (redirectClickId == null) {
    return;
  }
  const attachResult = apiRes<AttachRedirectAttributionResponse>();
  await API.attachRedirectAttribution(redirectClickId, attachResult);
  if (
    attachResult.error.value == null &&
    attachResult.data.value != null &&
    attachResult.data.value.success === true
  ) {
    clearStoredRedirectClickId();
    return;
  }
  console.error(
    "Failed to attach redirect attribution:",
    attachResult.error.value,
    attachResult.data.value,
  );
}
